import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { DataFreshnessProvider } from '@/components/layout/DataFreshnessContext';
import { Skeleton } from '@/components/ui/states';
import { FundsPage } from '@/pages/FundsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Routes.
 *
 * `/admin` and `/login` are owned by the admin workstream. They are lazy-imported
 * so this page's bundle does not carry them, and so replacing those two files
 * needs no change here.
 */
const AdminUploadPage = lazy(() => import('@/pages/AdminUploadPage'));
const LoginPage = lazy(() => import('@/pages/LoginPage'));

function RouteFallback() {
  return (
    <div className="p-6 space-y-3" role="status" aria-busy="true">
      <span className="sr-only">Memuat halaman</span>
      <Skeleton height={22} width="40%" />
      <Skeleton height={140} radius={12} />
    </div>
  );
}

export function App() {
  return (
    <DataFreshnessProvider>
      <AppShell>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Navigate to="/funds" replace />} />
            <Route path="/funds" element={<FundsPage />} />
            <Route path="/admin" element={<AdminUploadPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </AppShell>
    </DataFreshnessProvider>
  );
}

export default App;
